import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { fontStyles, linkStyles } from '../constants/styles';
import { isInternalURI } from '../helpers/location';
import { breakpoints } from '../constants/mediaqueries';
import { customMarkdown } from '../helpers/markdown';
import { fluidPropTypes } from '../types';

import ExternalLink from './ExternalLink';
import LocalisedLink from './LocalisedLink';
import MichelbergerImage from './MichelbergerImage';
import ModuleWrapper from './ModuleWrapper';


const Wrapper = styled(ModuleWrapper)`
  > a {
    display: block;
  }
`;

const Content = styled.div`
  margin-top: 1.25rem;

  p {
    margin: 1rem 0;
  }

  @media ${breakpoints.l} {
    display: flex;
    justify-content: space-between;
  }
`;

const TeaserTitle = styled.div`
  ${fontStyles.body}

  @media ${breakpoints.l} {
    width: calc(50% - 4vw);
  }
`;

const TeaserMarkdown = styled.div`
  ${fontStyles.bodySmall}

  a {
    ${linkStyles}
  }

  @media ${breakpoints.l} {
    width: calc(50% - 4vw);
  }
`;


const LargeTeaser = ({ block }) => {
  const { changesColorOnHover, hasBlendMode, image, imageUrl, text, title } = block;

  const mbImage = (
    <MichelbergerImage
      changesColorOnHover={changesColorOnHover}
      hasBlendMode={hasBlendMode}
      image={image}
    />
  );

  const wrapInLink = (content) => {
    if (imageUrl && isInternalURI(imageUrl)) {
      return (
        <LocalisedLink hasUnderline={false} to={imageUrl}>{content}</LocalisedLink>
      );
    }
    if (imageUrl) {
      return (
        <ExternalLink hasUnderline={false} href={imageUrl}>{content}</ExternalLink>
      );
    }
    return content;
  };

  return (
    <Wrapper>
      {wrapInLink(mbImage)}
      <Content>
        <TeaserTitle>{wrapInLink(customMarkdown(title))}</TeaserTitle>
        <TeaserMarkdown>{customMarkdown(text)}</TeaserMarkdown>
      </Content>
    </Wrapper>
  );
};

LargeTeaser.propTypes = {
  block: PropTypes.shape({
    id: PropTypes.string,
    changesColorOnHover: PropTypes.bool,
    hasBlendMode: PropTypes.bool,
    image: PropTypes.shape({
      id: PropTypes.string,
      fluid: fluidPropTypes,
      inlineSvg: PropTypes.string,
    }),
    imageUrl: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

export default LargeTeaser;
